module.exports = __webpack_public_path__ + "img/finding-1.50448d3c.png";